import React from 'react'
import { cn } from '@/utils/ui'

export interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  description?: string | null
  htmlFor?: string
  useNormalFontColor?: boolean
}

export const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>(
  ({ className, description, children, htmlFor, useNormalFontColor = true, ...props }, ref) => {
    return (
      <div className="flex flex-col">
        <label
          ref={ref}
          htmlFor={htmlFor}
          className={cn(
            '!text-label-XS-semibold',
            useNormalFontColor ? 'text-text-faded' : 'text-[#888888]',
            className,
          )}
          {...props}
        >
          {children}
        </label>
        {description && (
          <span
            className={cn(
              'text-label-XS-regular mt-0.5',
              useNormalFontColor ? 'text-text-subtle' : 'text-[#888888]',
            )}
          >
            {description}
          </span>
        )}
      </div>
    )
  },
)

FormLabel.displayName = 'FormLabel'
